import { io } from "socket.io-client";
const backendURL = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_BACKEND_PORT}`;
const socket = io(backendURL);

export default socket;
